import { render, staticRenderFns } from "./InviteFriend.vue?vue&type=template&id=793bd51b&scoped=true&"
import script from "./InviteFriend.vue?vue&type=script&lang=js&"
export * from "./InviteFriend.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriend.vue?vue&type=style&index=0&id=793bd51b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bd51b",
  null
  
)

export default component.exports